import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BinLockContainer, BinLockCustomContainer } from '../../../../../../models/aggregates/erp/stock';
import { BaseApiTemplateService, Core2Config, Pagination, ApiVisa, PagingResponseModel } from '../../shared';

@Injectable({ providedIn: 'root' })
export class BinLockService extends BaseApiTemplateService<BinLockContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'bins/lock/' + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.INV_PREFIX}bins/lock/` + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  getScrapByCriteria(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const finalUrl = this.apiUrl + '/query/scrap?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<BinLockCustomContainer>>(finalUrl, this.getHttpHeader(visa));
  }
}